import { useEffect, useMemo, useState } from "react";
import ReactTable from 'react-table';
import { AddUpdateApiConfigurationModal, BackButton, BadgeComponent, Breadcrumbs, DropDownComponent, IconButtonComponent, LoaderComponent, PaginationComponent } from "../../components";
import { VerticalDotsSvg } from "../../assets/svgs";
import { useDispatch, useSelector } from "react-redux";
import { AuthPageContainer, AuthPageHead, ReactTableWrapper, ReactTableWrappers } from "../../styles/global-styles";
import { getApiConfigList, getApiConfigValues, postAddUpdateApiConfiguration } from "../../redux/slices/api-config-slice";
import { fieldTypesConstant } from "../../constants/app-constants";
import { Menus } from "../../constants/menus-constant";
import { useLocation } from "react-router";
// import { providerInstitutionConstant } from "../../constants/user-constants";

const ApiConfigList = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.loginUserReducer);
    const { institutionsWithID } = useSelector((state) => state.institutionsListReducer);
    const { apiConfigAttributeNameOptions } = useSelector((state) => state.apiConfigReducer);
    const { loading, apiConfigData, pagination } = useSelector((state) => state.apiConfigReducer);

    const MenuList = Menus({ user });

    const { label: PageLabel, icon: PageIcon } = MenuList?.flatMap(i => i?.subMenus)?.filter(i => i?.to === location?.pathname)[0];

    const initialPagination = {
        currentPage: 0,
        pageSize: 20,
    };

    const initialOrderBy = {
        sortColumn: "createdDate",
        isAsce: false,
    };

    const initialSearch = {
        institutionId: '',
    };

    const initialForm = {
        cardInquiry: [],
        otpGenerator: [],
        otpValidator: [],
    };

    const initialStates = {
        data: [],
        pagination: initialPagination,
        orderBy: initialOrderBy,
        search: initialSearch,
        selected: null,
        isDropdownOpen: false,
        isModalOpen: false,
        isConfirmModal: false,
        isUpdate: false,
        isView: false,
        isFiltersOpen: false,
    };

    const [states, setStates] = useState(initialStates);

    const [form, setForm] = useState(initialForm);

    const defaultParams = { pagination: states.pagination, orderBy: states.orderBy, search: states.search };

    const getApiConfigListData = async (updatedParams) => {
        if (user && updatedParams) {
            try {
                await Promise.all([
                    dispatch(getApiConfigValues(user)),
                    dispatch(getApiConfigList({ user, ...updatedParams })),
                ]);
            } catch (error) {
                console.error("One or more API calls failed", error);
            }
        }
    };

    // const handleReload = () => {
    //     getApiConfigListData(defaultParams);
    //     handleCloseFilters();
    // };

    const handlePagination = (e) => {
        const params = {
            ...defaultParams,
            pagination: {
                ...defaultParams.pagination,
                currentPage: e
            }
        };
        getApiConfigListData(params);
    };

    // const handleChangeFilters = (e) => {
    //     const { name, value, type, checked } = e.target
    //     setStates((old) => ({
    //         ...old,
    //         search: ({
    //             ...old.search,
    //             [name]: ['checkbox', 'radio'].includes(type) ? checked : value
    //         })
    //     }));
    // };

    const handleSelectRow = (row) => {
        if (row === states.selected && states.isDropdownOpen) {
            setStates((old) => ({ ...old, isDropdownOpen: false, selected: null }));
        } else {
            setStates((old) => ({ ...old, isDropdownOpen: true, selected: row }));
        }
    };

    const handleCloseDropdown = () => {
        setStates((old) => ({ ...old, isDropdownOpen: false }));
    };

    // const handleToggleFilters = () => {
    //     setStates((old) => ({ ...old, search: initialSearch, isFiltersOpen: !states.isFiltersOpen }));
    // };

    // const handleCloseFilters = () => {
    //     setStates((old) => ({ ...old, search: initialSearch, isFiltersOpen: false }));
    // };

    const handleModalOpen = async (e) => {
        if (['update'].includes(e)) {
            // If updating, populate the form with existing configuration data
            if (states?.selected && states?.selected?.apiConfiguration) {
                const existingConfig = states?.selected?.apiConfiguration;
                setForm({
                    cardInquiry: existingConfig?.cardInquiry ? existingConfig?.cardInquiry?.map(item => ({
                        ...item,
                        attributeValue: (item?.attributeValue || ''),
                        attributeField: apiConfigAttributeNameOptions.some(option => option.value === item?.attributeName) ? fieldTypesConstant?.dropdown : fieldTypesConstant?.text,
                    })) : [],
                    otpGenerator: existingConfig?.otpGenerator ? existingConfig?.otpGenerator?.map(item => ({
                        ...item,
                        otpDelivery: (item?.otpDelivery?.id || ''),
                        attributeValue: (item?.attributeValue || ''),
                        attributeField: apiConfigAttributeNameOptions.some(option => option.value === item?.attributeName) ? fieldTypesConstant?.dropdown : fieldTypesConstant?.text,
                    })) : [],
                    otpValidator: existingConfig?.otpValidator ? existingConfig?.otpValidator?.map(item => ({
                        ...item,
                        attributeValue: (item?.attributeValue || ''),
                        attributeField: apiConfigAttributeNameOptions.some(option => option.value === item?.attributeName) ? fieldTypesConstant?.dropdown : fieldTypesConstant?.text,
                    })) : [],
                });
            } else {
                setForm(initialForm);
            }
            setStates((old) => ({ ...old, isModalOpen: true, isUpdate: true, isConfirmModal: false }));
        } else {
            setForm(initialForm);
            setStates((old) => ({ ...old, isModalOpen: true, isUpdate: false, isConfirmModal: false }));
        }
    };

    const handleModalClose = () => {
        setStates((old) => ({ ...old, isModalOpen: false, isConfirmModal: false, selected: null, isUpdate: false, isView: false }));
    };

    const handleFormSubmit = (payload) => {
        if (user && payload && states.selected) {
            const updatedPayload = {
                institution: states.selected?.institution,
                apiConfiguration: payload,
                isUpdate: states.isUpdate,
            };

            dispatch(postAddUpdateApiConfiguration({ user, body: updatedPayload, update: states.isUpdate })).then((action) => {
                if (action?.payload?.status === 201 || action?.payload?.status === 200) {
                    handleModalClose();
                    getApiConfigListData(defaultParams);
                }
            });
        }
    };

    const handleFiltersSubmit = (e, customSearch = null) => {
        if (e) e.preventDefault();
        const searchToUse = customSearch || states.search;
        const params = {
            ...defaultParams,
            search: searchToUse,
            pagination: initialPagination,
        };
        getApiConfigListData(params);
    };

    const handleTableFilterChange = (key, value, submit = false) => {
        setStates(old => {
            const updatedSearch = { ...old.search, [key]: value || '' };
            if (submit) {
                setTimeout(() => {
                    handleFiltersSubmit(null, updatedSearch);
                }, 0);
            }
            return { ...old, search: updatedSearch };
        });
    };

    const actions = (row) => {
        const actionsList = [];
        const hasCardInquiry = row?.apiConfiguration?.cardInquiry?.length > 0;
        const hasOtpGenerator = row?.apiConfiguration?.otpGenerator?.length > 0;
        const hasOtpValidator = row?.apiConfiguration?.otpValidator?.length > 0;
        const isConfigured = hasCardInquiry || hasOtpGenerator || hasOtpValidator;

        if (isConfigured) {
            actionsList.push({ label: 'Update Configuration', action: () => handleModalOpen('update') });
        } else {
            actionsList.push({ label: 'Add Configuration', action: () => handleModalOpen('add') });
        }

        return actionsList;
    };

    useEffect(() => {
        getApiConfigListData(defaultParams);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (apiConfigData && Array.isArray(apiConfigData)) {
            setStates((old) => ({ ...old, data: apiConfigData, pagination: pagination }));
        }
    }, [apiConfigData, pagination]);

    useEffect(() => {
        const handleClickOutside = (event) => {

            if (!event.target.closest('.action-dropdown')) {
                handleCloseDropdown();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // const searchFields = [
    //     {
    //         label: 'Institution',
    //         type: 'select',
    //         options: institutionsWithID,
    //         name: 'institutionId',
    //         value: states.search.institutionId,
    //     },
    //     {
    //         type: 'action',
    //         actions: [
    //             { label: 'Cancel', icon: CrossSvg, type: 'button', outline: true, action: handleToggleFilters },
    //             { label: 'Search', icon: SearchSvg, type: 'submit', action: () => { } }
    //         ],
    //     }
    // ];

    // TABLE COLUMNS SETUP AS PER DATA
    // const columns = [
    //     {
    //         field: 'participantName', 
    //         headerName: 'Participant Name', 
    //         width: 200,
    //         valueGetter: (row) => row?.institution?.descr || '',
    //         sortBy: (row) => row?.institution?.descr,
    //     },
    //     {
    //         field: 'cardInquirySetup',
    //         headerName: 'Card Inquiry Setup',
    //         width: 180,
    //         align: 'center',
    //         sortable: false,
    //         valueGetter: (row) => {
    //             const isConfigured = row?.apiConfiguration?.cardInquiry?.length > 0;
    //             return (
    //                 <BadgeComponent 
    //                     label={isConfigured ? "Configured" : "Not Configured"} 
    //                     type={isConfigured ? "success" : "default"}
    //                     outline={isConfigured ? false : true}
    //                 />
    //             )
    //         },
    //     },
    //     {
    //         field: 'generateOtpSetup',
    //         headerName: 'Generate OTP Setup',
    //         width: 180,
    //         align: 'center',
    //         sortable: false,
    //         valueGetter: (row) => {
    //             const otpGenerators = row?.apiConfiguration?.otpGenerator || [];

    //             if (otpGenerators.length === 0) {
    //                 return <BadgeComponent label="Not Configured" type="default" outline />;
    //             }

    //             // Check for different delivery types
    //             const deliveryTypes = [...new Set(otpGenerators
    //                 .filter(otp => otp.otpDelivery)
    //                 .map(otp => otp.otpDelivery.deliveryType))];

    //             if (deliveryTypes.length > 0) {
    //                 // Show only first 3 delivery types
    //                 const displayTypes = deliveryTypes.slice(0, 3);
    //                 const hasMore = deliveryTypes.length > 3;

    //                 return (
    //                     <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap', justifyContent: 'center' }}>
    //                         {displayTypes.map((type, index) => (
    //                             <BadgeComponent 
    //                                 key={index}
    //                                 label={type === 'In App Notification' ? 'In-App' : type} 
    //                                 type="success" 
    //                                 size="small"
    //                                 outline
    //                             />
    //                         ))}
    //                         {hasMore && (
    //                             <BadgeComponent 
    //                                 label={`+${deliveryTypes.length - 3}`}
    //                                 type="default" 
    //                                 size="small"
    //                             />
    //                         )}
    //                     </div>
    //                 );
    //             }

    //             return <BadgeComponent label="Configured" type="success" />;
    //         },
    //     },
    //     {
    //         field: 'otpValidationSetup',
    //         headerName: 'OTP Validation Setup',
    //         width: 180,
    //         align: 'center',
    //         sortable: false,
    //         valueGetter: (row) => {
    //             const isConfigured = row?.apiConfiguration?.otpValidator?.length > 0;
    //             return (
    //                 <BadgeComponent 
    //                     label={isConfigured ? "Configured" : "Not Configured"} 
    //                     type={isConfigured ? "success" : "default"}
    //                     outline={isConfigured ? false : true} 
    //                 />
    //             )
    //         },
    //     },
    //     {
    //         field: 'action',
    //         headerName: 'Actions',
    //         sortable: false,
    //         width: 100,
    //         align: 'right',
    //         sticky: 'right',
    //         valueGetter: (row) => {
    //             return (
    //                 <div className="action-dropdown" style={{ position: 'relative', float: 'right' }}>
    //                     <IconButtonComponent outline={!(states.isDropdownOpen && states.selected === row)} size='small' icon={VerticalDotsSvg} onClick={() => handleSelectRow(row)} />
    //                     <DropDownComponent isOpen={states.isDropdownOpen && states.selected === row} close={handleCloseDropdown} actions={actions(row)} />
    //                 </div>
    //             )
    //         },
    //     },
    // ];
    // TABLE COLUMNS SETUP AS PER DATA
    const columns = useMemo(() => [
        {
            accessor: 'participantName',
            Header: 'Participant Name',
            minWidth: 240,
            style: {
                textAlign: 'center'
            },
            Cell: (row) => row?.original?.institution?.descr || '',
            Filter: ({ filter, onChange }) => (
                <select
                    name="institutionId"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('institutionId', value, true);
                    }}
                    style={{ width: '100%' }}
                >
                    <option value="">All</option>
                    {
                        institutionsWithID?.map((item, index) => (
                            <option key={index} value={item.id || item.value}>
                                {item.descr || item.label}
                            </option>
                        ))
                    }
                </select>
            ),
            sortable: false,
            // filterable: false,
        },
        {
            accessor: 'cardInquirySetup',
            Header: 'Card Inquiry Setup',
            minWidth: 180,
            style: {
                textAlign: 'center',
            },
            Cell: (row) => {
                const isConfigured = row?.original?.apiConfiguration?.cardInquiry?.length > 0;
                return (
                    <BadgeComponent
                        label={isConfigured ? "Configured" : "Not Configured"}
                        type={isConfigured ? "success" : "default"}
                    // outline={isConfigured ? false : true}
                    />
                )
            },
            sortable: false,
            filterable: false,
        },
        {
            accessor: 'generateOtpSetup',
            Header: 'Generate OTP Setup',
            minWidth: 180,
            style: {
                textAlign: 'center',
            },
            Cell: (row) => {
                const otpGenerators = row?.original?.apiConfiguration?.otpGenerator || [];

                if (otpGenerators.length === 0) {
                    return <BadgeComponent label="Not Configured" type="default" />;
                }

                // Check for different delivery types
                const deliveryTypes = [...new Set(otpGenerators
                    .filter(otp => otp.otpDelivery)
                    .map(otp => otp.otpDelivery.deliveryType))];

                if (deliveryTypes.length > 0) {
                    // Show only first 3 delivery types
                    const displayTypes = deliveryTypes.slice(0, 3);
                    const hasMore = deliveryTypes.length > 3;

                    return (
                        <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap', justifyContent: 'center' }}>
                            {displayTypes.map((type, index) => (
                                <BadgeComponent
                                    key={index}
                                    label={type === 'In App Notification' ? 'In-App' : type}
                                    type="success"
                                    size="small"
                                />
                            ))}
                            {hasMore && (
                                <BadgeComponent
                                    label={`+${deliveryTypes.length - 3}`}
                                    type="default"
                                    size="small"
                                />
                            )}
                        </div>
                    );
                }

                return <BadgeComponent label="Configured" type="success" />;
            },
            sortable: false,
            filterable: false,
        },
        {
            accessor: 'otpValidationSetup',
            Header: 'OTP Validation Setup',
            minWidth: 180,
            style: {
                textAlign: 'center',
            },
            Cell: (row) => {
                const isConfigured = row?.original?.apiConfiguration?.otpValidator?.length > 0;
                return (
                    <BadgeComponent
                        label={isConfigured ? "Configured" : "Not Configured"}
                        type={isConfigured ? "success" : "default"}
                    // outline={isConfigured ? false : true}
                    />
                )
            },
            sortable: false,
            filterable: false,
        },
        {
            accessor: 'action',
            Header: 'Actions',
            minWidth: 100,
            // style: {
            //     height: 45, display: 'flex', justifyContent: 'flex-end', alignItems: 'center'
            // },
            Cell: (row) => {
                return (
                    <div className="action-dropdown" style={{ position: 'absolute' }}>
                        <IconButtonComponent outline={!(states.isDropdownOpen && states.selected === row?.original)} size='small' icon={VerticalDotsSvg} onClick={() => handleSelectRow(row?.original)} />
                        <DropDownComponent isOpen={states.isDropdownOpen && states.selected === row?.original} close={handleCloseDropdown} actions={actions(row?.original)} />
                    </div>
                )
            },
            sortable: false,
            filterable: false,
        },
    ], [states.isDropdownOpen, states.selected, institutionsWithID]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <AuthPageContainer $heightfull>
            {/* BACK BUTTON */}
            <BackButton />
            {/* PAGE HEAD */}
            <AuthPageHead>
                <div className="left">
                    <PageIcon className="page-icon" />
                    <h1>API Configurations</h1>
                    {/* <IconButtonComponent icon={ReloadSvg} outline size="small" disabled={loading} onClick={handleReload} className={loading && 'box-spin'} /> */}
                    <Breadcrumbs
                        items={[
                            { label: "Home", to: "/app/home" },
                            { label: PageLabel }
                        ]}
                        separator="›"
                        activeLastBreadcrumb={false}
                        size="small"
                        color={'var(--text-color-secondary)'}
                    />
                </div>

                <div className="right">
                    {/* <IconButtonComponent icon={FilterSvg} outline onClick={handleToggleFilters} /> */}
                </div>
            </AuthPageHead>

            {/* FILTER */}
            {/* {
                searchFields && searchFields.length > 0 &&
                <FiltersComponent open={states.isFiltersOpen} searchFields={searchFields} handleChange={handleChangeFilters} handleSubmit={handleFiltersSubmit} />
            } */}

            {/* LOADING STATE */}
            {
                loading &&
                <LoaderComponent />
            }

            {/* EMPTY STATE */}
            {/* {
                !loading && states.data && states.data.length === 0 &&
                <EmptyTableComponent text='No data found!' />
            } */}

            {/* PAGE CONTENT */}
            {
                <>
                   <PaginationComponent
                        page={states?.pagination?.currentPage}
                        pages={states?.pagination?.totalPages || 1}
                        onPageChange={(e) => handlePagination(e)}
                        canPrevious={states?.pagination?.currentPage > 0}
                        canNext={states?.pagination?.currentPage < (states?.pagination?.totalPages - 1)}
                    />
                    <ReactTableWrapper className="box-shadow custom-scrollbar">
                        {/* <TableComponent rows={states.data} columns={columns} icon={BadgeSvg} />
                    <PaginationComponent data={states.pagination} handleChange={(e) => handlePagination(e)} /> */}
                        <ReactTableWrappers>
                            <ReactTable
                                manual
                                loading={loading}
                                data={states?.data}
                                columns={columns}
                                page={states?.pagination?.currentPage || 0}
                                pageSize={states?.pagination?.pageSize || 20}
                                pages={states?.pagination?.totalPages || 1}
                                filterable={true}
                                showPagination={false}
                                showPageJump={true}
                                showPageSizeOptions={false}
                                showPaginationTop={true}
                                showPaginationBottom={false}
                                onPageChange={(e) => handlePagination(e)}
                                minRows={0}
                            // defaultFilterMethod={(filter, row, column) => {
                            //     return true;
                            // }}
                            // onFilteredChange={(filtered, column, value) => {
                            //     const searchCriteria = transformToObject(filtered);
                            //     setComponentState((prevState) => ({
                            //         ...prevState,
                            //         searchCriteria,
                            //         tableLoading: true,
                            //     }));

                            //     handleOnSearch(searchCriteria); // Trigger handle search
                            // }}
                            />
                        </ReactTableWrappers>
                    </ReactTableWrapper>
                </>
            }

            {/* MODAL */}
            {
                states.isModalOpen &&
                <AddUpdateApiConfigurationModal data={form} label={`${states.isView ? 'View' : states.isUpdate ? 'Update' : 'Add'} API Configuration`} institution={states?.selected?.institution} update={states.isUpdate} viewOnly={states.isView} close={handleModalClose} handleFormSubmit={handleFormSubmit} emptyBinRange={initialForm?.addParticipantBinRangeDto?.[0]} slide />
            }
        </AuthPageContainer>
    );
};

export default ApiConfigList;